import { render, staticRenderFns } from "./ReviewHistory.vue?vue&type=template&id=782f5a98&scoped=true"
import script from "./ReviewHistory.vue?vue&type=script&lang=ts"
export * from "./ReviewHistory.vue?vue&type=script&lang=ts"
import style0 from "./ReviewHistory.vue?vue&type=style&index=0&id=782f5a98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "782f5a98",
  null
  
)

export default component.exports